import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { HotelDetailContainer } from '@hotels/hotel-detail/hotel-detail.container';
import {
  SearchBarMobileCalendarContainer
} from '@shared/base-search-bar/components/calendar/components/search-bar-mobile-calendar/search-bar-mobile-calendar.container';
import { HotelRoomsMobileComponent } from '@hotels/hotel-detail/components/hotel-rooms-mobile/hotel-rooms-mobile.component';
import { HOTEL_DETAIL_BASE_ROUTE } from '@hotels/hotel-detail/constants/hotel-detail-route-params';

export const hotelDetailRootRoute = HOTEL_DETAIL_BASE_ROUTE;
export const hotelRoomsRootRoute = 'hotel-rooms';
export const calendarRoute = 'calendar';

export const routes: Routes = [
  {
    path: ':session_token/:search_id/:hotel_option_id/:rooms',
    component: HotelDetailContainer,
    children: [
      {
        path: calendarRoute,
        outlet: 'hotel-detail',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: calendarRoute,
        outlet: 'search',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: hotelRoomsRootRoute,
        outlet: 'hotel-detail',
        component: HotelRoomsMobileComponent
      }
    ]
  },
  {
    path: ':hotel_id/:arrival/:departure_date/:rooms/:currency',
    component: HotelDetailContainer,
    children: [
      {
        path: calendarRoute,
        outlet: 'hotel-detail',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: calendarRoute,
        outlet: 'search',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: hotelRoomsRootRoute,
        outlet: 'hotel-detail',
        component: HotelRoomsMobileComponent
      }
    ]
  },
  {
    path: ':hotel_id/:arrival/:departure_date/:arrival_date/:rooms/:currency',
    component: HotelDetailContainer,
    children: [
      {
        path: calendarRoute,
        outlet: 'hotel-detail',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: calendarRoute,
        outlet: 'search',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: hotelRoomsRootRoute,
        outlet: 'hotel-detail',
        component: HotelRoomsMobileComponent
      }
    ]
  },
  {
    path: ':session_token/:search_hotel_id/:hotel_option_id/:search_air_id/:air_option_id/:rooms/:package_step',
    component: HotelDetailContainer,
    children: [
      {
        path: calendarRoute,
        outlet: 'hotel-detail',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: calendarRoute,
        outlet: 'search',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: hotelRoomsRootRoute,
        outlet: 'hotel-detail',
        component: HotelRoomsMobileComponent
      }
    ]
  },
  {
    path: ':hotel_name/:departure/:arrival/:departure_date/:arrival_date/:rooms/:currency/:package_step',
    component: HotelDetailContainer,
    children: [
      {
        path: calendarRoute,
        outlet: 'hotel-detail',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: calendarRoute,
        outlet: 'search',
        component: SearchBarMobileCalendarContainer,
      },
      {
        path: hotelRoomsRootRoute,
        outlet: 'hotel-detail',
        component: HotelRoomsMobileComponent
      }
    ]
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HotelDetailRoutingModule { }
